import { translate } from 'components/Translation';
import errorCodes from './errorCodes';

export default class ErrorMapper {
	public static mapToMessage(code: string): string {
		const errorCode = errorCodes.get(code);
		return errorCode ? translate(errorCode.translationKey) : translate('error.occured');
	}
}
